<template>
  <div
    class="modal fade"
    id="StartEasycodeModal"
    tabindex="-1"
    aria-labelledby="StartEasycodeModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-slideout modal-lg modal-dialog-centered"
    >
      <div class="modal-content m-4 m-lg-0">
        <div class="row flex-column-reverse flex-lg-row p-4 p-lg-5">
          <div
            class="col-12 col-lg-6 text-center text-lg-start d-flex flex-column justify-content-between mt-3 mt-lg-0"
          >
            <button
              type="button"
              id="StartEasycodeModalClose"
              class="btn-close d-none"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
            <h2 class="text-primary modal-title">
              {{ "Ottimo lavoro " + name + "!" }}
            </h2>
            <p class="fs-4 modal-p mt-3">
              Il tuo personaggio è perfetto! Ora puoi iniziare la tua avventura
              nel magico mondo di Easycode.
            </p>
            <button @click="next()" type="button" class="btn btn-platform mt-3">
              INIZIA L'AVVENTURA
            </button>
          </div>
          <div class="col-12 col-lg-6 d-flex justify-content-center ps-0 ps-lg-5">
            <img
              class="img-fluid"
              src="@/assets/images/frame/reward3.svg"
              alt="floppy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "StartEasycodeModal",
  props: {
    name: String,
  },
  setup() {
    const router = useRouter();

    const next = () => {
      router.push("/");

      const closeModal = document.getElementById("StartEasycodeModalClose");
      closeModal?.click();
    };
    return { next };
  },
});
</script>

<style lang="scss" scoped>
.modal-title {
  font-weight: 600;
  font-size: 32px;
  line-height: 120%;
  letter-spacing: 0.01em;
}
.modal-p {
  font-weight: 500;
  line-height: 120%;
  letter-spacing: 0.01em;
}
</style>
